import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { capitalizeWords, formatRupiah } from "../../../Utils"

const Mutasihariraya = (periode, data, namaBulan, tahun) => {
  /* Cek data kosong atau ada isinya */
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }
  
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

const drawHeader = (judul, subJudul, logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(judul, pageWidth / 2, reportY, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(subJudul, pageWidth / 2, reportY + 6, {
    align: "center",
  });

  return reportY + 10;
};
  namaBulan = namaBulan || "Tidak Diketahui";
  tahun = tahun || "Tidak Diketahui";
  const title = `Laporan Mutasi Hari raya \n ${namaBulan} ${tahun}`;

 const judul = "Mutasi Simpanan Hari Raya";
 const subJudul = `${namaBulan} ${tahun}`;
 const headers = [[
  { content: "NO", styles: { halign: "center" } },
  { content: "NO ANGGOTA", styles: { halign: "center" } },
  { content: "NAMA", styles: { halign: "center" } },
  { content: "SALDO AWAL", styles: { halign: "center" } },
  { content: "SETOR", styles: { halign: "center" } },
  { content: "TARIK", styles: { halign: "center" } },
  { content: "JASA", styles: { halign: "center" } },
  { content: "SALDO AKHIR", styles: { halign: "center" } },
]];

  //const itemsPerPage = 50;
  let startY = 20;

  let totalSaldoAwal = 0;
  let totalSetor = 0;
  let totalTarik = 0;
  let totalJasa = 0;  
  let totalSaldoAkhir = 0;

  const tableData = data.map((item, index) => {
  const saldoawalValue = parseFloat(item.saldoawal) || 0;
  const setorValue = parseFloat(item.setor) || 0;
  const tarikValue = parseFloat(item.tarik) || 0;
  const terimajasaValue = parseFloat(item.terimajasa) || 0;
  const saldoakhValue = parseFloat(item.saldoakh) || 0;

  totalSaldoAwal += saldoawalValue;
  totalSetor += setorValue;
  totalTarik += tarikValue;
  totalJasa += terimajasaValue;
  totalSaldoAkhir += saldoakhValue;

  return [
    { content: index + 1, styles: { halign: "right" } },
    { content: item.noanggota ?? "-", styles: { halign: "center" } },
    capitalizeWords(item.nama),
    { content: formatRupiah(item.saldoawal), styles: { halign: "right" } },
    { content: formatRupiah(item.setor), styles: { halign: "right" } },
    { content: formatRupiah(item.tarik), styles: { halign: "right" } },
    { content: formatRupiah(item.terimajasa), styles: { halign: "right" } },
    { content: formatRupiah(item.saldoakh), styles: { halign: "right" } }
  ];
});

  tableData.push([
  { content: "TOTAL", colSpan: 3, styles: { halign: "center", fontStyle: "bold" } },
  { content: formatRupiah(totalSaldoAwal), styles: { halign: "right", fontStyle: "bold" } },
  { content: formatRupiah(totalSetor), styles: { halign: "right", fontStyle: "bold" } },
  { content: formatRupiah(totalTarik), styles: { halign: "right", fontStyle: "bold" } },
  { content: formatRupiah(totalJasa), styles: { halign: "right", fontStyle: "bold" } },
  { content: formatRupiah(totalSaldoAkhir), styles: { halign: "right", fontStyle: "bold" } }
]);

 const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY,

    theme: "grid",

    styles: {
      font: "helvetica",
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
      valign: "middle",
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },

    headStyles: {
      fillColor: [0, 191, 165],
      textColor: 255,
      fontStyle: "bold",
      fontSize: 8,
      halign: "center",
      valign: "middle",
      cellPadding: 2,
      lineWidth: 0.2,
      lineColor: [0, 0, 0],
    },

    bodyStyles: {
      textColor: [0, 0, 0],
    },

    alternateRowStyles: {
      fillColor: [255, 255, 255],
    },

    showHead: "everyPage",

    margin: {
      top: 20,
      left: 9,
      right: 9,
      bottom: 10,
    },

    tableWidth: "stretch",

    columnStyles: {
      0: {
        cellWidth: 10,
        halign: "center",
      },
      1: {
        cellWidth: 25,
        halign: "center",
      },
      2: {
        cellWidth: "auto",
        halign: "left",
      },
      3: {
        cellWidth: 25,
        halign: "right",
      },
      4: {
        cellWidth: 25,
        halign: "right",
      },
      5: {
        cellWidth: 25,
        halign: "right",
      },
      6: {
        cellWidth: 25,
        halign: "right",
      },
      7: {
        cellWidth: 25,
        halign: "right",
      },
    },

    didParseCell: (data) => {
      if (
        data.row.raw &&
        data.row.raw[0] &&
        data.row.raw[0].content === "TOTAL"
      ) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [230, 230, 230];
      }
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 6
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
      

  /*for (let i = 0; i < data.length; i += itemsPerPage) {
    if (i > 0) {
      doc.addPage();
      startY = 10;
    }

    const pageData = data.map((item,index) =>
      [
        {content: formatNumber(index + 1), styles: { halign: "right" }},
        { content: item.noanggota ?? "-", styles: { halign: "center" } },
        capitalizeWords(item.nama),
        { content: formatNumber(item.saldoawal), styles: { halign: "right" } },
        { content: formatNumber(item.setor), styles: { halign: "right" } },
        {content: formatNumber(item.tarik), styles: { halign: "right" } },
        { content: formatNumber(item.terimajasa), styles: { halign: "right" } },
        { content: formatNumber(item.saldoakh), styles: { halign: "right" } }
      ]
    );

    if (i + itemsPerPage >= data.length) {
      totalSaldoAwal = data.reduce((sum, item) => sum + (item.saldoawal ?? 0), 0);
      totalSetor = data.reduce((sum, item) => sum + (item.setor ?? 0), 0);
      totalTarik = data.reduce((sum, item) => sum + (item.tarik ?? 0), 0);
      totalJasa = data.reduce((sum, item) => sum + (item.terimajasa ?? 0), 0);
      totalSaldoAkhir = data.reduce((sum, item) => sum + (item.saldoakh ?? 0), 0);

      pageData.push([
        { content: "TOTAL", colSpan: 3, styles: { halign: "center", fontStyle: "bold" } },
        { content: formatNumber(totalSaldoAwal), styles: { halign: "right", fontStyle: "bold" } },
        { content: formatNumber(totalSetor), styles: { halign: "right", fontStyle: "bold" } },
        { content: formatNumber(totalTarik), styles: { halign: "right", fontStyle: "bold" } },
        { content: formatNumber(totalJasa), styles: { halign: "right", fontStyle: "bold" } },
        { content: formatNumber(totalSaldoAkhir), styles: { halign: "right", fontStyle: "bold" } }
      ]);
    }

    autoTable(doc, {
      head: headers,
      body: pageData,
      startY: startY,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 0.7 },
      headStyles: { halign: "left", valign: "middle", fontSize: 8, cellPadding: 2 },
      showHead: "everyPage",
      margin: { left: 9, right: 9 },
      tableWidth: "stretch",
      didParseCell: function (data) {
        if (data.row.raw && data.row.raw[0]?.content === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fontSize = 9;
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },
    });
  }*/

 const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(judul, subJudul, logoDataUrl);
    renderTable(startY);
  })
  .catch(() => {
    const startY = drawHeader(judul, subJudul);
    renderTable(startY);
  });
};

export default Mutasihariraya;